var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const SettingsApiService = {
    get: (extensionName = null, languagePath = null) => __awaiter(void 0, void 0, void 0, function* () {
        let uri = 'v1/zig-sitepackage/settings.json';
        if (languagePath) {
            uri = languagePath + uri;
        }
        // Make sure the request is relative to the current domain
        if (uri.charAt(0) !== '/') {
            uri = '/' + uri;
        }
        const response = yield fetch(uri);
        const responseData = yield response.json();
        if (extensionName) {
            return responseData[extensionName];
        }
        return responseData;
    }),
};
export default SettingsApiService;
